export const CheckIcon = ({
  size = 20,
  color = "#0A701B",
  className = "",
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`check-icon ${className}`}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}>
    <path d="M20 6L9 17L4 12" />
  </svg>
);

export const XIcon = ({
  size = 20,
  color = "#D90000",
  className = "",
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`x-icon ${className}`}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}>
    <path d="M18 6L6 18" />
    <path d="M6 6L18 18" />
  </svg>
);

export const CircleCheckIcon = ({
  size = 20,
  color = "#0A701B",
  className = "",
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`circle-check-icon ${className}`}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}>
    <circle cx="12" cy="12" r="10" />
    <path d="M16 8L10 14L8 12" />
  </svg>
);

export const CircleXIcon = ({
  size = 20,
  color = "#D90000",
  className = "",
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`circle-x-icon ${className}`}
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default" }}>
    <circle cx="12" cy="12" r="10" />
    <path d="M15 9L9 15" />
    <path d="M9 9L15 15" />
  </svg>
);
